/**
 * پالت‌های اپِ موبایل — عیناً همون مقادیری که تا امروز در core/lib/theme.ts بود.
 * دست نخوردن؛ فقط جاشون عوض شد. هر تغییری اینجا مستقیم روی گوشی دیده می‌شه.
 */
import type { Palette } from './palette.ts';

export type ThemeName = 'night' | 'coral';

export const PALETTES: Record<ThemeName, Palette> = {
  // شبانه: کهربایی روی سرمه‌ای
  night: {
    bg: '#0B1220', surface: '#141E33', surface2: '#1B2740', line: '#1F2C46',
    ink: '#E7ECF6', ink2: '#8C9AB8', ink3: '#5E6C89',
    brand: '#F0A83C', brandText: '#F0A83C', brandInk: '#1A1206',
    brandSoft: '#33280F', brandEdge: '#3C3117',
    accent: '#4FD1A5', accentSoft: '#12362B', accent2: '#8FE0C4', notice: '#F07B4A',
    danger: '#F2545B', warn: '#F0A83C', warnSoft: '#33280F',
    scrim: '#00000099', isDark: true,
  },
  // روزانه: مرجانی روی آبیِ پودری
  coral: {
    bg: '#EBF1F6', surface: '#FFFFFF', surface2: '#E2EAF1', line: '#D2DDE7',
    ink: '#12202B', ink2: '#4F606D', ink3: '#82929E',
    brand: '#E05A4A', brandText: '#B23C2E', brandInk: '#FFFFFF',
    brandSoft: '#FDEAE6', brandEdge: '#F6CDC6',
    accent: '#0A6E70', accentSoft: '#DCEFEF', accent2: '#3FA98A', notice: '#E08A3C',
    danger: '#C0392B', warn: '#B45309', warnSoft: '#FDF2E3',
    scrim: '#12202B66', isDark: false,
  },
};
